import instance from '@apis/instance';
import InitAddress from '@components/base/init-address';
import Layout from '@components/layouts/layout';
import NotAuthLayout from '@components/layouts/not-auth-layout';
import Nav from '@components/nav';
import PopupContainer from '@containers/popup';
import { signOut, useSession } from 'next-auth/react';
import React, { Dispatch, SetStateAction, useEffect } from 'react';

export default function AuthGuard({
  children,
  setSessionRefetchInterval,
  error,
}: {
  children: React.ReactNode;
  setSessionRefetchInterval: Dispatch<SetStateAction<number>>;
  error?: Record<string, any>;
}) {
  const { status, data: session } = useSession();

  if (process.env.NODE_ENV !== 'production' && session?.accessToken) {
    instance.defaults.headers['authorization'] = `${session?.accessToken}`;
  }

  useEffect(() => {
    if (session?.error === 'RefreshAccessTokenError') {
      signOut({ callbackUrl: '/sign-in' });
    }

    if (process.env.NODE_ENV !== 'production' && session?.accessToken) {
      instance.defaults.headers['authorization'] = `${session?.accessToken}`;
    }

    if (!!session) {
      const nowTime = Math.round(Date.now() / 1000);
      const timeRemaining =
        ((session as any).accessTokenExpires as number) - 7 * 60 - nowTime;

      setSessionRefetchInterval(timeRemaining > 0 ? timeRemaining : 1);
    }
  }, [session, setSessionRefetchInterval]);

  if (error && error.status === 401) {
    signOut();
    return <></>;
  }

  return (
    <InitAddress>
      {status !== 'loading' ? (
        status === 'authenticated' ? (
          <>
            <Layout>
              {children}
              <Nav />
            </Layout>
          </>
        ) : (
          status === 'unauthenticated' && (
            <>
              <NotAuthLayout>
                {children}
                <Nav />
              </NotAuthLayout>
            </>
          )
        )
      ) : (
        <div className="min-h-screen"></div>
      )}
      <PopupContainer />
    </InitAddress>
  );
}
